import { MARKETING_SECTION_HEADING_HIGHLIGHT_INFO_MESSAGE } from '@modules/whitelabel-cover-page/marketing-page-section/marketing-page-section.constants';

export const FEED_POSTS_GRID_LAYOUT_CONSTANTS = {
  LAYOUT_ID: 'feed-posts-grid-layout',
  LAYOUT_LABEL: 'Feed Posts Grid Layout',
  LAYOUT_DESCRIPTION:
    'Section heading with a responsive grid of feed post cards including captions, media, polls, and fundraisers',
  HEADING_POSITION_LEFT: 'left',
  HEADING_POSITION_CENTER: 'center',
  HEADING_POSITION_RIGHT: 'right',
  INFO_HEADING_HIGHLIGHT: MARKETING_SECTION_HEADING_HIGHLIGHT_INFO_MESSAGE,
  labels: {
    TITLE: 'Title',
    SECTION_HEADING: 'Heading',
    SUBHEADING: 'Subheading',
    HEADING_POSITION: 'Show Heading on',
    HEADING_POSITION_LEFT: 'Left',
    HEADING_POSITION_CENTER: 'Center',
    HEADING_POSITION_RIGHT: 'Right',
    FEED_POSTS: 'Feed Posts'
  },
  placeholders: {
    TITLE: 'Enter title',
    SECTION_HEADING: 'Enter heading',
    SUBHEADING: 'Enter subheading'
  },
  DATA_KEYS: {
    SECTION_TITLE: 'section_title',
    SECTION_HEADING: 'section_heading',
    SUBHEADING: 'subheading',
    HEADING_POSITION: 'heading_position',
    HEADING_FONT_SIZE: 'heading_font_size',
    FEED_POSTS: 'feed_posts',
    MAX_POST: 'max_post',
    FEED_SOURCE: 'feed_source'
  },
  FEED_SOURCE: {
    SELECT: 'select',
    AUTO_POPULATE: 'auto_populate'
  },
  POST_COUNT_OPTIONS: [3, 6, 9, 12, 15] as const
} as const;
